/**
 * Custom hook to manage filter panel logic
 * @param {Object} filters - Current filter state
 * @param {Array<string>} extraFilterKeys - Keys for extra filters
 * @returns {Object} Filter panel configuration
 */
export const useFilterPanels = (filters, extraFilterKeys) => {
  const countSelections = (filterKeys) => {
    return filterKeys.reduce((count, key) => {
      const value = filters[key];
      if (Array.isArray(value) && value.length > 0) {
        return count + value.length;
      }
      return count;
    }, 0);
  };

  const extraCount = countSelections(extraFilterKeys);
  const hasAnyFilters = extraCount > 0;
  const defaultActiveKeys = hasAnyFilters ? ['1', '2'] : ['1'];

  return {
    extraCount,
    hasAnyFilters,
    defaultActiveKeys,
    countSelections,
  };
};
